import { useState } from 'react';
import './ContactoForm.css';

function ContactoForm({ title }) {
  const [status, setStatus] = useState(''); // '', 'loading', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('/send_email.php', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <>
      <div className="card">
        <span className="title">{title}</span>
        <form className="form" onSubmit={handleSubmit}>
          <div className="group">
            <input
              placeholder=""
              type="text"
              name="first_name"
              required
            />
            <label htmlFor="nombre">Nombre</label>
          </div>
          <div className="group">
            <input
              placeholder=""
              type="tel"
              id="telefono"
              name="telephone"
            />
            <label htmlFor="telefono">Teléfono</label>
          </div>
          <div className="group">
            <input
              placeholder=""
              type="email"
              id="email"
              name="email"
              required
            />
            <label htmlFor="email">Email</label>
          </div>
          <div className="group">
            <label htmlFor="comentario">Consulta</label>
            <textarea
              placeholder=""
              id="comentario"
              name="message"
              rows={5}
              required
            />
          </div>
          <div className="group btnsubmit-div">
            <button type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? 'Enviando...' : 'Solicitar Asesoría'}
            </button>
          </div>
          {status === 'success' && <p style={{color: 'green', marginTop: '10px', textAlign: 'center'}}>¡Gracias! Nos pondremos en contacto a la brevedad.</p>}
          {status === 'error' && <p style={{color: 'red', marginTop: '10px', textAlign: 'center'}}>Hubo un error al enviar. Por favor intenta más tarde.</p>}
        </form>
      </div>
    </>
  );
}

export default ContactoForm;
